const NAME = 'mail';

export const SEND_MAIL_PENDING = `${NAME}/SEND_MAIL_PENDING`;
export const SEND_MAIL_FAILED = `${NAME}/SEND_MAIL_FAILED`;
export const SEND_MAIL_COMPLETED = `${NAME}/SEND_MAIL_COMPLETED`;
